import { insuranceAPI } from "./InsuranceService";

const userApi = insuranceAPI.injectEndpoints({
  endpoints: (build) => ({
    getUsers: build.mutation({
      query: (body) => ({
        url: `/users/all-users`,
        method: "POST",
        body,
      }),
      transformResponse: (response) => {
        response?.items?.map((item) => {
          item.id = `${item.id}/${item.naicCode}`;
        });
        return response;
      },
    }),
    getRoles: build.query({
      query: () => ({
        url: `/users/all-user-roles`,
      }),
    }),
    getAssociations: build.query({
      query: () => ({
        url: `/users/all-user-associations`,
      }),
    }),
    blockUser: build.mutation({
      query: (body) => ({
        url: `/users/block-unblock-user`,
        method: "POST",
        body,
      }),
      async onQueryStarted(value, { dispatch, queryFulfilled }) {
        await queryFulfilled;

        try {
          dispatch(
            userApi.util.updateQueryData("getUsers", "", (draft) => {
              draft.forEach((item) => {
                if (item.id === value.userInternalId) {
                  item.isBlocked = value.isBlocked;
                }
              });
            })
          );
        } catch (e) {
          console.error("Error in onQueryStarted:", e);
        }
      },
    }),
    createUser: build.mutation({
      query: (body) => ({
        url: `/users/create-user`,
        method: "POST",
        body,
      }),
      async onQueryStarted(value, { dispatch, queryFulfilled }) {
        try {
          const { data: newUser } = await queryFulfilled;

          dispatch(
            userApi.util.updateQueryData("getUsers", "", (draft) => {
              draft.push(newUser);
            })
          );
        } catch (e) {
          console.log("Error in onQueryStarted:", e);
        }
      },
    }),
    changePassword: build.mutation({
      query: (body) => ({
        url: `/users/change-password`,
        method: "POST",
        body,
      }),
    }),
  }),
});
export const {
  useGetUsersMutation,
  useGetAssociationsQuery,
  useGetRolesQuery,
  useBlockUserMutation,
  useCreateUserMutation,
  useChangePasswordMutation,
} = userApi;
